module.exports = __webpack_public_path__ + "img/confused.be5030ca.webp";